import * as z from "zod";
import type { TFunction } from "i18next";

const requiredText = (t: TFunction, key: string) =>
  z.string().trim().min(1, t(key));

/** PRD admin-structures.md §4.6 — Mapeamento de risco (somente Barragem). */
export const createAdminStructureRiskMappingSchema = (t: TFunction) =>
  z.object({
    wasteType: requiredText(
      t,
      "admin.structures.riskMapping.validation.wasteTypeRequired",
    ),
    downstreamHumanOccupation: requiredText(
      t,
      "admin.structures.riskMapping.validation.downstreamHumanOccupationRequired",
    ),
    downstreamEnvironmentalInterest: requiredText(
      t,
      "admin.structures.riskMapping.validation.downstreamEnvironmentalInterestRequired",
    ),
    downstreamInstallation: requiredText(
      t,
      "admin.structures.riskMapping.validation.downstreamInstallationRequired",
    ),
  });

export type AdminStructureRiskMappingForm = z.infer<
  ReturnType<typeof createAdminStructureRiskMappingSchema>
>;
